// extracted by mini-css-extract-plugin
module.exports = {"root":"home-header-module--root--26H_A","text":"home-header-module--text--3Z4q5 typography-module--responsiveTitle3--3gljT","animation":"home-header-module--animation--3bb-6"};